import { Loja, Venda } from '@/models'
import { ClienteGrupoEconomico } from '@/models/GrupoEconomico'
import { VendaModule } from '@/store/vuex/venda/VendaStore'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { consultar } from '@/api/creditoInformado'

export default async function validarCreditoInformadoDoCliente(
	venda: Venda,
	loja: Loja,
	vendaModule = VendaModule,
): Promise<void> {
	if (!venda.cliente) return

	let resposta
	try {
		resposta = await consultar(venda.cliente.cnpjOuCpf, loja.id)
	} catch {
		return
	}

	if (!resposta.integracaoConfigurada) return

	const grupos = venda.cliente.gruposEconomicos || []
	const indice = grupos.findIndex(grupo => grupo.grupoEconomico.id === loja.grupoEconomico.id)

	const grupoAtualizado: ClienteGrupoEconomico = {
		...(indice >= 0 ? grupos[indice] : {
			id: '',
			clienteId: venda.cliente.id,
			grupoEconomico: loja.grupoEconomico,
			limiteDoCrediario: 0,
			disponivelEmCrediario: 0,
		} as ClienteGrupoEconomico),
		limiteInformado: resposta.limiteInformado,
		disponivelEmLimiteInformado: resposta.disponivelInformado,
		bloqueadoCreditoInformado: resposta.bloqueado,
		motivosBloqueioCreditoInformado: resposta.motivosBloqueio.join('; '),
	}

	if (indice >= 0) {
		grupos.splice(indice, 1, grupoAtualizado)
	} else {
		grupos.push(grupoAtualizado)
	}
	venda.cliente.gruposEconomicos = grupos

	if (resposta.bloqueado) {
		AlertModule.setError(
			`Cliente bloqueado${resposta.motivosBloqueio.length ? ': ' + resposta.motivosBloqueio.join(', ') : ''}`,
		)
	} else if (resposta.consultaIndisponivel) {
		AlertModule.setWarning('Não foi possível confirmar o crédito do cliente agora. A consulta está indisponível.')
	}

	if (resposta.bloqueado || resposta.consultaIndisponivel) {
		const motivoPadrao = resposta.bloqueado
			? `Cliente bloqueado: ${resposta.motivosBloqueio.join(', ') || 'motivo não informado'}`
			: 'Consulta de crédito indisponível (plugin desativado ou rota fora do ar)'

		const autenticacao = await vendaModule.autenticarAcaoTelaDeCaixa({
			regra: 'pode-liberar-cliente-bloqueado-por-consulta-api',
			motivoPadrao,
			regraParaAutoLiberacao: 'pode-conceder-limite-de-crediario',
		})
		if (autenticacao?.autenticado) venda.liberarCrediario = true
	}
}
